import { render, staticRenderFns } from "./cancelAppoint.vue?vue&type=template&id=5bd89462&"
import script from "./cancelAppoint.vue?vue&type=script&lang=js&"
export * from "./cancelAppoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports